<div class="e-card custom-panel" [hidden]="_selectedWidgetType === null">
  <div class="e-panel-container dpc">
    <ng-container #viewContainer2></ng-container>
  </div>
</div>
